var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.twitterUrl},on:{"click":_vm.openTwitter}},[_c('SaIcon',{attrs:{"name":"twitter-brands"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }